/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

// generate prototype of Error
import {AxiosError} from 'axios';

/**
 * CORS exception type.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default class CorsException extends Error {
    constructor(public axiosError: AxiosError) {
        super();
    }
}
